import "libphonenumber-js-utils";

// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX = /^^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9][a-zA-Z\-0-9]*\.)+[a-zA-Z]{2,}))$/;

export const validateEmail = (value) => {
  if (typeof value !== "undefined") {
    let matches = value.match(EMAIL_REGEX);
    if (matches === null) {
      return false;
    }

    let maxLocalPartLen = 64;
    return matches[1].length <= maxLocalPartLen;
  } else {
    return;
  }
};

export const matchValues = (initialValue, newValue) => {
  return initialValue === newValue;
};
